function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M16.0001 1.74988C16.811 2.06655 17.5751 2.47667 18.2792 2.967C21.1327 4.95427 23.0001 8.25905 23.0001 12C23.0001 18.0751 18.0753 23 12.0001 23C8.25917 23 4.95439 21.1326 2.96712 18.279C2.47679 17.575 2.06667 16.8109 1.75 16C1.75 16 2.69065 16.301 4.13403 16.3775C6.41125 16.4983 9.93984 16.0603 13.0001 13C16.0604 9.93972 16.4984 6.41113 16.3777 4.13391C16.3011 2.69052 16.0001 1.74988 16.0001 1.74988ZM14.4143 14.4142C17.3287 11.4998 18.2194 8.19348 18.3703 5.64174C19.9961 7.27089 21.0001 9.51923 21.0001 12C21.0001 16.9706 16.9707 21 12.0001 21C9.51936 21 7.27102 19.996 5.64186 18.3701C8.1936 18.2193 11.4999 17.3286 14.4143 14.4142ZM7.00009 3.41421L8.41432 4.82844L7.00013 6.24264L8.41434 7.65686L9.82854 6.24266L11.2427 7.65685L12.6569 6.24264L11.2428 4.82845L12.657 3.41422L11.2428 2L9.82854 3.41423L8.41431 2L7.00009 3.41421ZM6 13C7.10457 13 8 12.1046 8 11C8 9.89543 7.10457 9 6 9C4.89543 9 4 9.89543 4 11C4 12.1046 4.89543 13 6 13Z",
  fill: "white"
});

var SvgSwitchToEveningIcon = function SvgSwitchToEveningIcon(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgSwitchToEveningIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/switch-to-evening-icon.0073a1fa.svg";
export { ForwardRef as ReactComponent };